import React from "react";
import { getValueAverage } from "../misc/helperfuncs";

const ArrayInfo = ({ objectArray, values, handleObject, textColor }) => {
  return (
    <div
      className="divRow"
      style={{ justifyContent: "space-around", width: "100%", zIndex: 1 }}
    >
      {values.map((o) => (
        <ValueHolder
          textColor={textColor}
          name={o.name}
          value={o.value}
          icon={o.icon}
          objectArray={objectArray}
          key={o.name}
        />
      ))}
    </div>
  );
};

const ValueHolder = ({ objectArray = [], name, icon, value, textColor }) => {
  return (
    <div className="divColumn">
      <div className="divRow">
        <img src={icon} className="icon20" />
        <div style={{ color: textColor }}>
          {getValueAverage(objectArray, value)}
        </div>
      </div>
      <div className="textBold" style={{ color: "#1f1f1f" }}>
        {name}
      </div>
    </div>
  );
};

export default ArrayInfo;
